import React, { Component } from 'react';
import config from 'react-global-configuration';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../../i18n/getLocale';

class ClientGroupTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      country_list: [],
      id: this.props.group_id,
      group_data: this.props.group_data,
      group_aircrafts: this.props.group_data.aircrafts,
      aircrafts_avaliable: this.props.group_data.aircrafts_avaliable,
      staff_avaliable: this.props.group_data.staff_avaliable,
    };
    this.AircraftActionsButtons = this.AircraftActionsButtons.bind(this);
    this.AircraftAvaliableActionsButtons = this.AircraftAvaliableActionsButtons.bind(this);

    this.StaffActionsButtons = this.StaffActionsButtons.bind(this);
    this.StaffAvaliableActionsButtons = this.StaffAvaliableActionsButtons.bind(this);

    this.addAircraft = this.addAircraft.bind(this);
    this.deleteAircraft = this.deleteAircraft.bind(this);

    this.addStaffCopil = this.addStaffCopil.bind(this);
    this.addStaffCms = this.addStaffCms.bind(this);
    this.addStaffCmdt = this.addStaffCmdt.bind(this);
    this.deleteStaff = this.deleteStaff.bind(this);

    // Handlers
    this.locale = getLocale();

  }
  // LM
  componentWillReceiveProps(newProps) {
    this.setState({
      id: newProps.group_id,
      group_data: newProps.group_data,
      group_aircrafts: newProps.group_data.aircrafts,
      group_staff: newProps.group_data.staff,
      aircrafts_avaliable: newProps.group_data.aircrafts_avaliable,
      staff_avaliable: newProps.group_data.staff_avaliable,
    });
  }

  addAircraft(event) {
    event.preventDefault();
    var datasave = {
      aircraft_id: event.currentTarget.value,
      client_group_id: this.state.id,
    };
    var self = this;
    var header = self.props.RequestApi.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/cliente/grupo/aeronave', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.refreshGroups(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addStaffCopil(event) {
    event.preventDefault();
    var datasave = {
      staff_id: event.currentTarget.value,
      client_group_id: this.state.id,
      role: 'copil',
    };
    var self = this;
    var header = self.props.RequestApi.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/cliente/grupo/tripulante', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.refreshGroups(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addStaffCms(event) {
    event.preventDefault();
    var datasave = {
      staff_id: event.currentTarget.value,
      client_group_id: this.state.id,
      role: 'cms',
    };
    var self = this;
    var header = self.props.RequestApi.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/cliente/grupo/tripulante', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.refreshGroups(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addStaffCmdt(event) {
    event.preventDefault();
    var datasave = {
      staff_id: event.currentTarget.value,
      client_group_id: this.state.id,
      role: 'cmdt',
    };
    var self = this;
    var header = self.props.RequestApi.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/cliente/grupo/tripulante', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.refreshGroups(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  AircraftAvaliableActionsButtons (cell, row) {
    var disabled = false;
    if (row.is_scalable === false) {
      disabled = true;
    }
    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-success" value={cell} disabled={disabled} onClick={this.addAircraft}>
          {this.locale.Clientes.EditarCliente.tabGrupoCliente.botaoEscalar}
        </button>
      </div>
    );

    return botao;
  }

  AircraftActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-danger" value={row.client_group_aircraft_id} onClick={this.deleteAircraft}>
          {this.locale.Clientes.EditarCliente.tabGrupoCliente.botaoDesescalar}
        </button>
      </div>
    );

    return botao;
  }

  StaffAvaliableActionsButtons (cell, row) {
    var disabled_COPIL = false;
    var disabled_CMDT = false;
    var disabled_CMS = false;
    if (row.roles.cmdt === false) {
      disabled_CMDT = true;
    }
    if (row.roles.cms === false) {
      disabled_CMS = true;
    }
    if (row.roles.copil === false) {
      disabled_COPIL = true;
    }
    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-primary" value={cell} disabled={disabled_COPIL} onClick={this.addStaffCopil}>
          {this.locale.Clientes.EditarCliente.tabGrupoCliente.botaoCOPIL}
        </button>
        <button className="btn btn-sm btn-success" value={cell} disabled={disabled_CMDT} onClick={this.addStaffCmdt}>
          {this.locale.Clientes.EditarCliente.tabGrupoCliente.botaoCDMT}
        </button>
        <button className="btn btn-sm btn-primary" value={cell} disabled={disabled_CMS} onClick={this.addStaffCms}>
          {this.locale.Clientes.EditarCliente.tabGrupoCliente.botaoCMS}
        </button>
      </div>
    );

    return botao;
  }

  StaffActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-danger" value={row.client_group_staff_id} onClick={this.deleteStaff}>
          {this.locale.Clientes.EditarCliente.tabGrupoCliente.botaoDesescalar}
        </button>
      </div>
    );

    return botao;
  }

  deleteAircraft (event) {
    var client_group_aircraft_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Clientes.EditarCliente.tabGrupoCliente.deletarAeronave);
    if (confirm) {
      var self = this;
      self.props.handleAlert('', '', 'open');
      var header = self.props.RequestApi.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/cliente/grupo/aeronave/' + client_group_aircraft_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.props.RequestApi.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.refreshGroups(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  deleteStaff (event) {
    var client_group_aircraft_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Clientes.EditarCliente.tabGrupoCliente.deletarTripulante);
    if (confirm) {
      var self = this;
      self.props.handleAlert('', '', 'open');
      var header = self.props.RequestApi.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/cliente/grupo/tripulante/' + client_group_aircraft_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.props.RequestApi.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.refreshGroups(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  render() {
    return (
<div>
  <div className="row">
    <h3>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaAeronaves.tituloAeronaves}</h3>
    <div className="col-md-6">
     <h4>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaAeronaves.aeronavesDisponiveis}</h4>
     <hr/>
      <BootstrapTable data={this.state.aircrafts_avaliable} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaAeronaves.semAeronaves}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaAeronaves.IDaeronave}</TableHeaderColumn>

        <TableHeaderColumn dataField="registration" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaAeronaves.Aeronave}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.AircraftAvaliableActionsButtons} width='100'>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaAeronaves.AcoesAeronave}</TableHeaderColumn>

      </BootstrapTable>
    </div>
    <div className="col-md-6">
      <h4>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaAeronaves.tituloEscalados}</h4>
      <hr/>
      <BootstrapTable data={this.state.group_aircrafts} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaAeronaves.semAeronaveEscaladas}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaAeronaves.IDaeronaveEscalada}</TableHeaderColumn>

        <TableHeaderColumn dataField="registration" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaAeronaves.AeronaveEscalada}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.AircraftActionsButtons} width='100'>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaAeronaves.AcoesEscalada}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
  <div className="row">
    <h3>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaTripulantes.tituloTripulantes}</h3>
    <div className="col-md-6">
     <h4>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaTripulantes.tripulanteDisponivel}</h4>
     <hr/>
      <BootstrapTable data={this.state.staff_avaliable} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaTripulantes.semTripulantes}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaTripulantes.IDtripulante}</TableHeaderColumn>

        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaTripulantes.Tripulante}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.StaffAvaliableActionsButtons} width='250'>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaTripulantes.AcoesTripulante}</TableHeaderColumn>

      </BootstrapTable>
    </div>
    <div className="col-md-6">
      <h4>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaTripulantes.tituloEscalados}</h4>
      <hr/>
      <BootstrapTable data={this.state.group_staff} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaTripulantes.semTripulantesEscalados}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaTripulantes.IDescalado}</TableHeaderColumn>

        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaTripulantes.TripulanteEscalado}</TableHeaderColumn>

        <TableHeaderColumn dataField="role_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaTripulantes.CargoEscalado}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.StaffActionsButtons} width='100'>{this.locale.Clientes.EditarCliente.tabGrupoCliente.tabelaTripulantes.AcoesEscalado}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default ClientGroupTab;



// WEBPACK FOOTER //
// ./src/Components/Clients/Elements/ClientGroupTab.js